var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgArchive = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: "1em",
  height: "1em",
  viewBox: "0 0 16 16",
  fill: "currentColor",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "m8 8.391 2.829 2.828-.944.944-1.218-1.219v3.723H7.333v-3.724l-1.218 1.22-.944-.944L8 8.391Zm0-7.057a4.668 4.668 0 0 1 4.636 4.13A3.667 3.667 0 0 1 12 12.652V11.31a2.332 2.332 0 0 0 1.65-3.543 2.332 2.332 0 0 0-2.392-1.064 3.333 3.333 0 1 0-6.518 0 2.333 2.333 0 1 0-.861 4.587l.12.02v1.343a3.667 3.667 0 0 1-.636-7.19A4.667 4.667 0 0 1 8 1.334Z"
})));
export default SvgArchive;